import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { SchedulingWidget } from '@carbonify/ui';

interface SchedulingBlockRecord extends CdaStructuredTextRecord {
  calendarUrl: string;
}

export default function SchedulingBlock({ calendarUrl }: SchedulingBlockRecord) {
  return <SchedulingWidget calendarUrl={calendarUrl} />;
}
